import * as React from 'react';

export function WeeklyPredictions() {
  return (
    <section className="verdu-predictions">
      <style>{`
        .verdu-predictions {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .verdu-predictions-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .verdu-predictions h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
          text-align: center;
        }
        .verdu-predictions .subtitle {
          font-size: 20px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
          text-align: center;
        }
        .verdu-predictions .intro {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 32px;
          text-align: center;
          max-width: 640px;
          margin-left: auto;
          margin-right: auto;
        }
        .verdu-factors-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 32px;
        }
        .verdu-factor {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 18px 20px;
          background: #fff;
          border-radius: 12px;
          border: 1px solid #eee;
        }
        .verdu-factor-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .verdu-factor-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .verdu-factor-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .verdu-factor-text p {
          font-size: 14px;
          color: #666;
          margin: 0;
          line-height: 1.5;
        }
        .verdu-predictions .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 0;
          padding: 20px 24px;
          background: #fff;
          border-radius: 12px;
          border: 1px solid #eee;
        }
        @media (max-width: 640px) {
          .verdu-predictions h2 {
            font-size: 24px;
          }
          .verdu-factors-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="verdu-predictions-inner">
        <h2>Accedé a nuestras predicciones semanales</h2>
        <p className="subtitle">Planificá tus costos de reposición</p>
        <p className="intro">
          El precio de la fruta y la verdura depende de muchos factores que cambian semana a semana.
          Nosotros los monitoreamos por vos, para que no tengas que pasear por todo el Mercado de Abasto.
        </p>

        <div className="verdu-factors-grid">
          <div className="verdu-factor">
            <div className="verdu-factor-icon"><i className="fa fa-cloud-sun" /></div>
            <div className="verdu-factor-text">
              <h3>Clima en zonas de producción</h3>
              <p>Heladas, granizo o sequías que afectan la cosecha y los precios.</p>
            </div>
          </div>
          <div className="verdu-factor">
            <div className="verdu-factor-icon"><i className="fa fa-calendar-alt" /></div>
            <div className="verdu-factor-text">
              <h3>Época del año</h3>
              <p>Estacionalidad que define la oferta y calidad de cada producto.</p>
            </div>
          </div>
          <div className="verdu-factor">
            <div className="verdu-factor-icon"><i className="fa fa-truck" /></div>
            <div className="verdu-factor-text">
              <h3>Ingreso de mercadería</h3>
              <p>Cuánta mercadería entró a la ciudad y cómo impacta en los precios.</p>
            </div>
          </div>
          <div className="verdu-factor">
            <div className="verdu-factor-icon"><i className="fa fa-seedling" /></div>
            <div className="verdu-factor-text">
              <h3>Estado de cosechas</h3>
              <p>Si se pudo cosechar o no, y cómo afecta la disponibilidad.</p>
            </div>
          </div>
        </div>

        <p className="closing">
          Nos mantenemos al tanto para que vos te enfoques en vender.
        </p>
      </div>
    </section>
  );
}
